import React from 'react';

import { useState } from 'react';
import {
  IndexPageWrapperProps,
  PageToolbar,
  PageToolbarProps,
  DrawerFilter,
} from '../../../../../base/presentation/components';
import { EnumStatusData } from '../../../../../base/domain/entities';
import {
  notificationFailed,
  notificationSuccess,
} from '../../../../../base/infrastructure/helpers';
import {
  useCurrentRoute,
  usePageProvider,
} from '../../../../../base/presentation/hooks';
import {
  DataTableContextEntity,
  DataTableProvider,
} from '../../../../../base/presentation/providers';
import { Modal, Spin } from 'antd';
import { PageWrapper } from './page-wrapper';
import { LoadingOutlined } from '@ant-design/icons';
import { DrawerImport } from '../page-drawer/drawer-import';
import { PageToolbarSimple } from '../page-toolbar-simple';

export function IndexPageWrapper(props: IndexPageWrapperProps) {
  const {
    children,
    padding,
    pageToolbarProps,
    drawerFilterProp,
    drawerImportProps,
    showPageHeader = true,
    showPageHeaderSimple = false,
    filterSearchKey = 'search',
  } = props;
  const { dataSource, navigation, transformer } = usePageProvider();
  const { loadingDataTable, setLoadingDataTable } = usePageProvider();
  const { recordDataTable, setRecordDataTable } = usePageProvider();
  const { selectedDataTable, setSelectedDataTable } = usePageProvider();
  const { metaDataTable, setMetaDataTable } = usePageProvider();
  const { filterDataTable, setFilterDataTable } = usePageProvider();
  const { transformerFilterIndexTable, transformerGetIndex } = transformer;
  const [currentRoute] = useCurrentRoute();
  const [showContent, setShowContent] = useState(true);
  const [visibleDrawerFilter, setVisibleDrawerFilter] = useState(false);
  const [visibleDrawerImport, setVisibleDrawerImport] = useState(false);

  function toggleDrawerFilter() {
    setVisibleDrawerFilter(!visibleDrawerFilter);
  }

  function toggleDrawerImport() {
    setVisibleDrawerImport(!visibleDrawerImport);
  }

  function manipulationKeyData(response: any[], currentData = []): any[] {
    const data = transformerGetIndex(response ?? []);
    const newData = data.map((item: any) => {
      const currentItem = currentData.find(
        (current: any) => current.id === item.id
      );
      if (currentItem) return undefined;
      return {
        ...item,
        key: item.id,
      };
    });
    return newData.filter(Boolean);
  }

  async function handleGetDataIndex({
    filter,
    isLoadMore,
  }: {
    filter?: any;
    isLoadMore?: boolean;
  }): Promise<void> {
    setLoadingDataTable(true);
    const payloadFilter = { page: 1, limit: 50, ...(filter ?? {}) };
    await dataSource.handleGetIndex({
      params: transformerFilterIndexTable(payloadFilter),
      onSuccess: ({ response }: any) => {
        if (isLoadMore) {
          const items =
            manipulationKeyData(response.items, recordDataTable) ?? [];
          setRecordDataTable([...recordDataTable, ...items]);
        } else {
          const items = manipulationKeyData(response.items) ?? [];
          setRecordDataTable(items);
        }
        setMetaDataTable(response.meta);
        setFilterDataTable(filter);
        setLoadingDataTable(false);
      },
      onFailed: ({ message }: any) => {
        setLoadingDataTable(false);
        notificationFailed([message]);
      },
    });
  }

  async function reloadData() {
    await handleGetDataIndex({
      filter: {
        ...(filterDataTable ?? {}),
        page: 1,
      },
    });
  }

  async function handleDelete(payload): Promise<void> {
    await dataSource.handleDelete(payload, {
      onSuccess: ({ response }: any) => {
        notificationSuccess([response]);
        setRecordDataTable(
          recordDataTable.filter((item: any) => item.id !== payload.id)
        );
        setMetaDataTable({
          ...metaDataTable,
          totalItems: metaDataTable.totalItems - 1,
        });
      },
      onFailed: ({ message }: any) => {
        notificationFailed([message]);
      },
    });
  }

  async function handleBatchDelete(payload = []): Promise<void> {
    await dataSource.handleBatchDelete(payload, {
      onSuccess: ({ response }: any) => {
        const responseItems = response ?? [];
        const successMessage = responseItems
          .filter(item => item.type === 'success')
          .map(itemMsg => itemMsg.message);

        const failedMessage = responseItems
          .filter(item => item.type === 'failed')
          .map(itemMsg => itemMsg.message);

        if (successMessage.length > 0) notificationSuccess(successMessage);
        if (failedMessage.length > 0) notificationFailed(failedMessage);
        reloadData();
      },
      onFailed: ({ message }: any) => {
        notificationFailed([message]);
      },
    });
  }

  async function handleConfirmProcess(payload): Promise<void> {
    await dataSource.handleConfirmProcess(payload, {
      onSuccess: ({ response }: any) => {
        notificationSuccess(['Successfully confirmed']);
        // const newItem = transformerGetIndex(response ? [response] : [])[0];
        // const newRecord = recordDataTable.map((item: any) => {
        //   if (item.id !== newItem.id) return item;
        //   return {
        //     ...newItem,
        //     key: newItem.id,
        //   };
        // });
        // setRecordDataTable(newRecord);
        reloadData();
      },
      onFailed: ({ message }: any) => {
        notificationFailed([message]);
      },
    });
  }

  async function handleBatchConfirmProcess(payload = []): Promise<void> {
    await dataSource.handleBatchConfirmProcess(payload, {
      onSuccess: ({ response }: any) => {
        const responseItems = response ?? [];
        const successMessage = responseItems
          .filter(item => item.type === 'success')
          .map(itemMsg => itemMsg.message);

        const failedMessage = responseItems
          .filter(item => item.type === 'failed')
          .map(itemMsg => itemMsg.message);

        if (successMessage.length > 0) notificationSuccess(successMessage);
        if (failedMessage.length > 0) notificationFailed(failedMessage);
        reloadData();
      },
      onFailed: ({ message }: any) => {
        notificationFailed([message]);
      },
    });
  }

  async function handleActivate(payload): Promise<void> {
    await dataSource.handleActivate(payload, {
      onSuccess: ({ response }: any) => {
        notificationSuccess(['Successfully activated']);
        // const newItem = transformerGetIndex(response ? [response] : [])[0];
        // const newRecord = recordDataTable.map((item: any) => {
        //   if (item.id !== newItem.id) return item;
        //   return {
        //     ...newItem,
        //     key: newItem.id,
        //   };
        // });
        // setRecordDataTable(newRecord);
        reloadData();
      },
      onFailed: ({ message }: any) => {
        notificationFailed([message]);
      },
    });
  }

  async function handleBatchActivate(payload = []): Promise<void> {
    await dataSource.handleBatchActivate(payload, {
      onSuccess: ({ response }: any) => {
        const responseItems = response ?? [];
        const successMessage = responseItems
          .filter(item => item.type === 'success')
          .map(itemMsg => itemMsg.message);

        const failedMessage = responseItems
          .filter(item => item.type === 'failed')
          .map(itemMsg => itemMsg.message);
        if (successMessage.length > 0) notificationSuccess(successMessage);
        if (failedMessage.length > 0) notificationFailed(failedMessage);
        reloadData();
      },
      onFailed: ({ message }: any) => {
        notificationFailed([message]);
      },
    });
  }

  async function handleDeactivate(payload): Promise<void> {
    await dataSource.handleDeactivate(payload, {
      onSuccess: ({ response }: any) => {
        notificationSuccess(['Successfully deactivated']);
        // const newItem = transformerGetIndex(response ? [response] : [])[0];
        // const newRecord = recordDataTable.map((item: any) => {
        //   if (item.id !== newItem.id) return item;
        //   return {
        //     ...newItem,
        //     key: newItem.id,
        //   };
        // });
        // setRecordDataTable(newRecord);
        reloadData();
      },
      onFailed: ({ message }: any) => {
        notificationFailed([message]);
      },
    });
  }

  async function handleBatchDeactivate(payload = []): Promise<void> {
    await dataSource.handleBatchDeactivate(payload, {
      onSuccess: ({ response }: any) => {
        const responseItems = response ?? [];
        const successMessage = responseItems
          .filter(item => item.type === 'success')
          .map(itemMsg => itemMsg.message);

        const failedMessage = responseItems
          .filter(item => item.type === 'failed')
          .map(itemMsg => itemMsg.message);

        if (successMessage.length > 0) notificationSuccess(successMessage);
        if (failedMessage.length > 0) notificationFailed(failedMessage);
        reloadData();
      },
      onFailed: ({ message }: any) => {
        notificationFailed([message]);
      },
    });
  }

  function handleClickDetail(row: any) {
    navigation.goToDetail({ id: row.id });
  }

  function handleClickUpdate(row: any) {
    navigation.goToUpdate({ id: row.id });
  }

  function handleClickDuplicate(row: any) {
    navigation.goToDuplicate({ id: row.id });
  }

  function handleClickNewData() {
    navigation.goToCreate();
  }

  function handleClickBack() {
    navigation.goBack(currentRoute);
  }

  function handleClickPrint() {
    window.print();
  }

  async function handleClickReload(): Promise<void> {
    setShowContent(false);
    await new Promise(resolve => setTimeout(resolve, 500));
    setShowContent(true);
  }

  function handleClickBatchDelete(): void {
    Modal.confirm({
      mask: true,
      okText: 'Confirm',
      title: 'Delete Confirmation',
      content: 'Are you sure you want to delete selected data?',
      onOk: () => handleBatchDelete(selectedDataTable),
    });
  }
  function handleClickDelete(row): void {
    Modal.confirm({
      mask: true,
      okText: 'Confirm',
      title: 'Delete Confirmation',
      content: 'Are you sure you want to delete this data?',
      onOk: () => handleDelete(row),
    });
  }

  function handleClickBatchConfirmProcess(): void {
    Modal.confirm({
      mask: true,
      okText: 'Confirm Process',
      title: 'Confirm Process Confirmation',
      content: 'Are you sure you want to confirm the selected data?',
      onOk: () => handleBatchConfirmProcess(selectedDataTable),
    });
  }

  function handleClickConfirmProcess(row): void {
    Modal.confirm({
      mask: true,
      okText: 'Confirm Process',
      title: 'Activate Confirmation',
      content: 'Are you sure you want to activate this data?',
      onOk: () => handleConfirmProcess(row),
    });
  }

  function handleClickBatchActivate(): void {
    Modal.confirm({
      mask: true,
      okText: 'Confirm',
      title: 'Activate Confirmation',
      content: 'Are you sure you want to activate the selected data?',
      onOk: () => handleBatchActivate(selectedDataTable),
    });
  }

  function handleClickActivate(row): void {
    Modal.confirm({
      mask: true,
      okText: 'Confirm',
      title: 'Activate Confirmation',
      content: 'Are you sure you want to activate this data?',
      onOk: () => handleActivate(row),
    });
  }

  function handleClickBatchDeactivate(): void {
    Modal.confirm({
      mask: true,
      okText: 'Confirm',
      title: 'Deactivate Confirmation',
      content: 'Are you sure you want to deactivate the selected data?',
      onOk: () => handleBatchDeactivate(selectedDataTable),
    });
  }

  function handleClickDeactivate(row): void {
    Modal.confirm({
      mask: true,
      okText: 'Confirm',
      title: 'Deactivate Confirmation',
      content: 'Are you sure you want to deactivate this data?',
      onOk: () => handleDeactivate(row),
    });
  }

  function handleClickFilter() {
    toggleDrawerFilter();
  }

  function handleClickImport() {
    toggleDrawerImport();
  }

  function makeDefaultSearch() {
    if (filterDataTable) return filterDataTable[filterSearchKey];
    return undefined;
  }

  const PageToolbarProperty: PageToolbarProps = {
    showDataTypeSelector: false,
    showApproval: false,
    showUpdate: false,
    showDuplicate: false,
    showDelete: selectedDataTable?.length > 0 ? true : false,
    showActivate: selectedDataTable?.length > 0 ? true : false,
    showDeactivate: selectedDataTable?.length > 0 ? true : false,
    showConfirmProcess: selectedDataTable?.length > 0 ? true : false,
    showExport: false,
    showImport: false,
    showPrint: false,
    showSave: false,

    handleClickBack,
    handleClickReload,
    handleClickFilter,
    handleClickImport,
    handleClickNewData,
    handleClickDelete: handleClickBatchDelete,
    handleClickActivate: handleClickBatchActivate,
    handleClickDeactivate: handleClickBatchDeactivate,
    handleClickConfirmProcess: handleClickBatchConfirmProcess,

    handleClickPrint,

    defaultSearchValue: makeDefaultSearch(),
    handleSearch(search) {
      handleGetDataIndex({
        filter: {
          ...(filterDataTable ?? {}),
          [`${filterSearchKey}`]: search,
          page: 1,
        },
      });
    },
    ...pageToolbarProps,
  };

  const initValueDataTableProvider: DataTableContextEntity = {
    recordDataTable,
    setRecordDataTable,
    selectedDataTable,
    setSelectedDataTable,
    metaDataTable,
    setMetaDataTable,
    filterDataTable,
    setFilterDataTable,
    loadingDataTable,
    setLoadingDataTable,
    handleGetDataIndex,
    handleDelete: handleClickDelete,
    handleConfirmProcess: handleClickConfirmProcess,
    handleActivate: handleClickActivate,
    handleDeactivate: handleClickDeactivate,
    handleUpdate: handleClickUpdate,
    handleDuplicate: handleClickDuplicate,
    handleDetail: handleClickDetail,
  };

  return (
    <div>
      <DrawerFilter
        className="drawer-filter-index"
        visible={visibleDrawerFilter}
        onSubmitFilter={filter => {
          handleGetDataIndex({
            filter: { ...(filterDataTable ?? {}), ...filter, page: 1 },
          });
        }}
        onClose={() => toggleDrawerFilter()}
        defaultValueFilter={filterDataTable}
        {...(drawerFilterProp ?? {})}
      />
      <DrawerImport
        className="drawer-filter-index"
        visible={visibleDrawerImport}
        onClose={() => toggleDrawerImport()}
        defaultValueFilter={filterDataTable}
        {...(drawerImportProps ?? {})}
      />
      {showPageHeader && <PageToolbar {...PageToolbarProperty} />}
      {!showPageHeader && showPageHeaderSimple && (
        <PageToolbarSimple {...PageToolbarProperty} />
      )}
      <PageWrapper padding={padding}>
        <Spin
          spinning={!showContent}
          indicator={<LoadingOutlined />}
          style={{ minHeight: '50vh' }}
        >
          {showContent && (
            <DataTableProvider initialValue={initValueDataTableProvider}>
              {children}
            </DataTableProvider>
          )}
        </Spin>
      </PageWrapper>
    </div>
  );
}
